; (function (jQuery) {
    "use strict";

    function CountyFields() {
        var fn = {
            init: function () {
                var addressGroups = jQuery('.county-address-group');
                addressGroups.each(fn.initGroup);
            },

            initGroup: function(i, elem) {
                const countryField = jQuery(elem).find('[name=country]');
                const provinceField = jQuery(elem).find('[name=county]');
                let initialValue = provinceField.val();
                const options = provinceField.find('option').detach();

                function doFilter() {
                    const countryId = countryField.val();
                    const provinceIds = window.baat_states.filter(function(elem) {
                        return elem['country_id'] == countryId
                    }).map(function(elem) {
                        return parseInt(elem.id, 10);
                    });

                    provinceField.empty().append(options.filter(function() {
                        return provinceIds.includes(parseInt(this.value, 10)) || this.value == '' || this.value == '0';
                    }));

                    if (provinceIds.includes(parseInt(initialValue, 10))) {
                        provinceField.val(initialValue);
                        initialValue = null;
                    } else {
                        provinceField.val('0');
                    }

                    provinceField.trigger('change');

                    if (provinceIds.length <= 1) {
                        provinceField.parents('.text-field').addClass('text-field--disabled');
                        provinceField.prop('disabled', true);
                    } else {
                        provinceField.parents('.text-field').removeClass('text-field--disabled');
                        provinceField.prop('disabled', false);
                    }
                }

                countryField.on('change', doFilter);
                doFilter();
            }
        }

        jQuery(fn.init);
    }

    new CountyFields();
})(jQuery);